import React, { useEffect, useLayoutEffect } from "react";
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";

import PageScrollTop from './components/pageToTop/PageScrollTop'

// Pages import Here 
import Home from "./pages/Home";
import Freelancer from "./pages/Freelancer";



import CategoryList from "./pages/CategoryList";
import TagList from "./pages/TagList";
import Author from "./pages/Author";
import AboutUs from "./pages/AboutUs";

// Elements import Here 

import Contact from "./elements/contact/Contact";
import BlogGridView from "./components/blog/BlogGridView";
import BlogListView from "./components/blog/BlogListView";
import BlogGridSidebar from "./components/blog/BlogGridSidebar";
import BlogListSidebar from "./components/blog/BlogListSidebar";
import BlogDetails from "./pages/BlogDetails";
import Error from "./pages/Error";

// Self Import 
import Content from './pages/services/Content';
import SignUp from './pages/others/Registration'
import Login from './pages/others/Login';

import Speaking from './pages/services/Speaking';
import Training from './pages/services/Training';
import Consulting from './pages/services/Consulting';
import TrainingBook from './pages/services/TrainingBook';
import SpeakingBook from './pages/services/SpeakingBook';
import ConsultingBook from './pages/services/ConsultingBook';

import PrivacyPolicy from './pages/others/PrivacyPolicy';
import TermsandCondition from './pages/others/TermsandCondition';
import Course from './pages/course/Course';
import CourseDetails from './pages/course/CourseDetails';
import Affiliate from './pages/services/Affiliate';
import Thanks from './pages/others/Thanks';
import Audit from './pages/others/Audit';
import Media from './pages/others/Media';
import Podcast from './pages/others/Podcast';
import Dashboard from './pages/dashboard/Dashboard';
import CoursePlaylist from './pages/course/CoursePlay';
import Order from './pages/others/Order';
import OrderSuccess from './pages/others/OrderSuccess';
import OrderCancel from './pages/others/OrderCancel';
import Pdf from './pages/others/Pdf';


// Import Css Here 
import './assets/scss/style.scss';
import Community from './pages/services/Community';
import Consultant from './elements/team/Consultant';
import ConsultantProfile from './elements/team/ConsultantProfile';
import ResetPassword from './pages/others/ResetPassword';
import PrivateRoute from './utils/PrivateRoute';




function AffiliateTracker() {
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const refId = queryParams.get("affiliator"); // or "ref", whichever you use

        if (refId) {
            const expiresAt = Date.now() + 30 * 24 * 60 * 60 * 1000;
            localStorage.setItem(
                "affiliate",
                JSON.stringify({ id: refId, expires: expiresAt })
            );
        } else {
            const existing = localStorage.getItem("affiliate");
            if (existing) {
                const { expires } = JSON.parse(existing);
                if (Date.now() > expires) {
                    localStorage.removeItem("affiliate");
                }
            }
        }
    }, [location.search]);

    return null; // This component just tracks affiliate and renders nothing
}


const App = () => {



    return (
        <Router>
            <PageScrollTop>
                <Switch>
                    <Route path={`${process.env.PUBLIC_URL + "/"}`} exact component={Home} />

                    {/* Blog Part  */}
                    <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} exact component={BlogGridView} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-list-view"}`} exact component={BlogListView} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-grid-sidebar"}`} exact component={BlogGridSidebar} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-list-sidebar"}`} exact component={BlogListSidebar} />
                    <Route path={`${process.env.PUBLIC_URL + "/blog-details/:id"}`} exact component={BlogDetails} />
                    <Route path={`${process.env.PUBLIC_URL + "/category/:slug"}`} exact component={CategoryList} />
                    <Route path={`${process.env.PUBLIC_URL + "/archive/:slug"}`} exact component={Author} />
                    <Route path={`${process.env.PUBLIC_URL + "/tag/:slug"}`} exact component={TagList} />

                    <Route path={`${process.env.PUBLIC_URL + "/contact"}`} exact component={Contact} />
                    <Route path={`${process.env.PUBLIC_URL + "/about-us"}`} exact component={AboutUs} />


                    {/* This is service Route for */}
                    <Route path={`${process.env.PUBLIC_URL + "/community"}`} exact component={Community} />
                    <Route path={`${process.env.PUBLIC_URL + "/traning"}`} exact component={Freelancer} />
                    <Route path={`${process.env.PUBLIC_URL + "/speaker"}`} exact component={Speaking} />
                    <Route path={`${process.env.PUBLIC_URL + "/speaker/book"}`} exact component={SpeakingBook} />

                    {/* Course Route */}
                    <Route path={`${process.env.PUBLIC_URL + "/course"}`} exact component={Course} />
                    <Route path={`${process.env.PUBLIC_URL + "/course-details/:slug"}`} exact component={CourseDetails} />


                    <Route path={`${process.env.PUBLIC_URL + "/course/category/:slug"}`} exact component={CategoryList} />
                    <Route path={`${process.env.PUBLIC_URL + "/course-tag/:slug"}`} exact component={TagList} />


                    <Route path={`${process.env.PUBLIC_URL + "/trainer"}`} exact component={Training} />
                    <Route path={`${process.env.PUBLIC_URL + "/trainer/book"}`} exact component={TrainingBook} />
                    <Route path={`${process.env.PUBLIC_URL + "/consultent"}`} exact component={Consulting} />
                    <Route path={`${process.env.PUBLIC_URL + "/consultent/book"}`} exact component={ConsultingBook} />

                    {/* Other Pages */}
                    <Route path={`${process.env.PUBLIC_URL + "/signup"}`} exact component={SignUp} />
                    <Route path={`${process.env.PUBLIC_URL + "/login"}`} exact component={Login} />
                    <Route path={`${process.env.PUBLIC_URL + "/password-reset"}`} exact component={ResetPassword} />
                    <Route path={`${process.env.PUBLIC_URL + "/content"}`} exact component={Content} />

                    <Route path={`${process.env.PUBLIC_URL + "/privacy-policy"}`} exact component={PrivacyPolicy} />
                    <Route path={`${process.env.PUBLIC_URL + "/terms-and-condition"}`} exact component={TermsandCondition} />

                    {/* Testing Route */}
                    <Route path={`${process.env.PUBLIC_URL + "/consultant"}`} exact component={Consultant} />
                    <Route path="/consultant/:id" component={ConsultantProfile} />
                    <Route path="/affiliate" component={Affiliate} />
                    <Route path="/thank-you" component={Thanks} />
                    <Route path="/audit" component={Audit} />
                    <Route path="/media" component={Media} />
                    <Route path="/podcast" component={Podcast} />
                    <Route path="/pdf" component={Pdf} />


                    {/* This is all private Route */}
                    <PrivateRoute path="/dashboard" component={Dashboard} />
                    <PrivateRoute path="/course-playlist/:slug" component={CoursePlaylist} />
                    <PrivateRoute path="/content/all" component={BlogGridSidebar} />
                    <PrivateRoute path="/content-details/:id" component={BlogDetails} />
                    <PrivateRoute path="/order" component={Order} />
                    <PrivateRoute path="/order-success" component={OrderSuccess} />
                    <PrivateRoute path="/order-cancelled" component={OrderCancel} />




                    <Route component={Error} />



                </Switch>
            </PageScrollTop>
        </Router>
    )
}


export default App
